import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ExpenseCategory {
  id: string;
  name: string;
  slug: string;
  type: string;
  parent_id: string | null;
  icon: string | null;
  color: string | null;
  sort_order: number;
  budget_monthly_usd: number | null;
  budget_monthly_brl: number | null;
  is_active: boolean;
  created_at: string;
}

export function useExpenseCategories() {
  return useQuery({
    queryKey: ['expense-categories'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('expense_categories')
        .select('*')
        .eq('is_active', true)
        .order('sort_order')
        .order('name');
      
      if (error) throw error;
      return data as ExpenseCategory[];
    },
  });
}

/**
 * Group categories by their type for dropdown display
 */
export function groupCategories(categories: ExpenseCategory[]) {
  const grouped: Record<string, ExpenseCategory[]> = {};
  
  for (const category of categories) {
    const group = category.type || 'other';
    if (!grouped[group]) {
      grouped[group] = [];
    }
    grouped[group].push(category);
  }
  
  return grouped;
}
